import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

interface EditUserInfoDialogData {
  id: string;
}

@Component({
  selector: 'meu-edit-user-info',
  templateUrl: './edit-user-info.component.html',
  styleUrls: ['./edit-user-info.component.scss'],
})
export class EditUserInfoComponent implements OnInit {
  UserId: string;
  constructor(
    public dialogRef: MatDialogRef<EditUserInfoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EditUserInfoDialogData
  ) {
    this.UserId = this.data.id;
  }

  ngOnInit() {}

  closeModal() {
    this.dialogRef.close();
  }
}
